import { render } from "./loadingAnim.vue?vue&type=template&id=2ea87da6&scoped=true&lang=pug"
const script = {}

import "./loadingAnim.vue?vue&type=style&index=0&id=2ea87da6&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea87da6"]])

export default __exports__